<template>
  <va-sidebar :minimized="minimizedProxy">
    <template slot="menu">

      <template v-for="service in filteredSidebarItems">
        <va-sidebar-link-group
          :key="service.id"
          :minimized.sync="minimizedProxy"
          :icon="service.icon"
          v-if="service.components"
          :slug="service.slug"
          :title="$t('menu.'+service.service)"
          :children="service.components">
          <va-sidebar-link
            v-for="(component, index) in service.components"
            :key="index"
            :to="{ name: `${service.isMetaService ? service.meta : service.slug}${component.component}` }"
            :title="$t(`menu.${component.component}`)"
          />
        </va-sidebar-link-group>
      </template>
    </template>
  </va-sidebar>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'app-sidebar',
  components: {
  },
  props: {
    minimized: {
      type: Boolean,
      required: true,
    },
  },
  methods: {
    hasRole: function (role) {
      if (this.$auth.check()) return this.$auth.user().roles.includes(role)
      return false
    },
    isFromEntity: function (entity) {
      if (this.$auth.check()) return this.$auth.user().entity.id === entity
      return null
    },
    hasPermission: function (permission) {
      return true
    }
  },
  computed: {
    minimizedProxy: {
      get () {
        return this.minimized
      },
      set (minimized) {
        this.$emit('update:minimized', minimized)
      },
    },
    ...mapGetters([
      'sidebarItems'
    ]),
    filteredSidebarItems: function () {
      return this.sidebarItems
        .map(service => {
          return {
            ...service,
            components: service.components.filter(component => component.meta !== 'hidden')
          }
        })
        .filter(service => service.components.length)
    }
  }
}

</script>
<style lang="scss">

$assetsPath: "../../../assets";
@import '@/sass/icons/icons-classes.scss';

.va-sidebar-link-group__submenu a {
  padding-left: 2.55rem;
}
.va-sidebar-link__content {
  i {
    width: 1.5rem !important;
  }

}
.va-sidebar-link-group--minimized .va-sidebar-link--active {
  .va-sidebar-link__content {
    &__icon {
      &.i-menu-stats-dark {
        @extend .i-menu-stats-light;
      }
      &.i-menu-audiology-dark {
        @extend .i-menu-audiology-light;
      }
      &.i-menu-booking-dark {
        @extend .i-menu-booking-light;
      }
      &.i-menu-config-dark {
        @extend .i-menu-config-light;
      }
      &.i-menu-evollu-dark {
        @extend .i-menu-evollu-light;
      }
      &.i-menu-reports-dark {
        @extend .i-menu-reports-light;
      }
      &.i-menu-evollu-dark {
        @extend .i-menu-acustica-light;
      }
      &.i-menu-acustica-dark {
        @extend .i-menu-acustica-light;
      }
    }
  }
}
</style>
